import React, { useEffect } from 'react';
import {
  HotelCard,
  HotelCardSmall,
  MapHotelCard,
  MapHotelCardSmall,
} from 'src/components/HotelCard';
import { getHotelCardProps, getMapHotelCardProps } from './utils';
import type { HotelRendererProps } from './types';

const HotelRenderer = (props: HotelRendererProps) => {
  const { id, isMobile, getImages, isMapCard } = props;

  // При маунте карточки получаем все изображения (они грузятся отдельной ручкой)
  useEffect(() => {
    getImages(id);
  }, [getImages, id]);

  if (isMapCard) {
    const mapHotelCardProps = getMapHotelCardProps(props);
    const Component = isMobile ? MapHotelCardSmall : MapHotelCard;

    return <Component {...mapHotelCardProps} />;
  }

  const hotelCardProps = getHotelCardProps(props);
  const Component = isMobile ? HotelCardSmall : HotelCard;

  return <Component {...hotelCardProps} />;
};

export default React.memo(HotelRenderer);
